import { CheckCircle } from "lucide-react";
import OptimizedImage from "../../../utils/landing/OptimizedImage";

export function AboutSection() {
  return (
    <section
      id="sobre-nosotros"
      className="py-16 bg-gradient-to-b from-white to-secondary-custom"
    >
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-primary-custom mb-4">
            Sobre Nosotros
          </h2>
          <div className="w-24 h-1 bg-primary-custom mx-auto rounded-full"></div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-primary-custom/10 rounded-full -z-10"></div>
              <h3 className="text-2xl font-bold text-primary-custom mb-4">
                Nuestra Historia
              </h3>
              <p className="text-lg text-gray-600 text-justify mb-6">
                Fundado en 1998, I.E.P. San Isidro ha sido un pilar de
                excelencia educativa en Zaña por más de dos décadas. Nuestra
                institución nació con la visión de ofrecer una educación
                integral que combine los valores tradicionales con metodologías
                pedagógicas efectivas, preparando a nuestros estudiantes para
                los desafíos del futuro.
              </p>
            </div>
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-primary-custom/10 rounded-full -z-10"></div>
              <h3 className="text-2xl font-bold text-primary-custom mb-4">
                Nuestro Compromiso
              </h3>
              <p className="text-lg text-gray-600 text-justify mb-6">
                A lo largo de los años, hemos mantenido nuestro compromiso con
                la formación académica rigurosa y el desarrollo personal de cada
                estudiante. Nuestro enfoque tradicional se complementa con una
                atención personalizada, reconociendo que cada niño y adolescente
                tiene talentos y necesidades únicas que merecen ser atendidas
                con dedicación y profesionalismo.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
              <div className="flex items-start gap-2">
                <CheckCircle className="h-6 w-6 text-primary-custom flex-shrink-0 mt-1" />
                <div>
                  <h4 className="font-semibold text-gray-800">
                    Excelencia Académica
                  </h4>
                  <p className="text-sm text-gray-600">
                    Programas educativos de alta calidad
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <CheckCircle className="h-6 w-6 text-primary-custom flex-shrink-0 mt-1" />
                <div>
                  <h4 className="font-semibold text-gray-800">
                    Atención Personalizada
                  </h4>
                  <p className="text-sm text-gray-600">
                    Cada estudiante es único
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <CheckCircle className="h-6 w-6 text-primary-custom flex-shrink-0 mt-1" />
                <div>
                  <h4 className="font-semibold text-gray-800">
                    Valores Tradicionales
                  </h4>
                  <p className="text-sm text-gray-600">
                    Formación integral y ética
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <CheckCircle className="h-6 w-6 text-primary-custom flex-shrink-0 mt-1" />
                <div>
                  <h4 className="font-semibold text-gray-800">
                    Metodologías Efectivas
                  </h4>
                  <p className="text-sm text-gray-600">
                    Técnicas pedagógicas modernas
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="relative">
            <div className="relative h-[500px] rounded-xl overflow-hidden shadow-xl">
              <OptimizedImage
                src="/img/landing/sobre-nosotros.webp"
                alt="Estudiantes en clase"
                fill
                className="object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            </div>
            {/* Elemento decorativo */}
            <div className="absolute -bottom-6 -right-6 bg-primary-custom text-white mr-3 p-6 rounded-lg shadow-lg z-10">
              <div className="font-heading text-4xl font-bold">25+</div>
              <div className="text-sm">Años de excelencia educativa</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
